<script>
    let show = true;
    setTimeout(() => {
        show = false;
    }, 5500);
</script>

<section>
    {#if show}
        <div class="main">
            <div class="videogif">
                <video width="100%" height="100%" autoplay loop muted>
                    <source
                        src="/images/createmain/story.mp4"
                        type="video/mp4"
                    />
                </video>
            </div>
        </div>
    {/if}
</section>

<style>
    .main {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background-color: black;
        z-index: 4;
    }
    .videogif {
        background-color: black;
        position: absolute;
        width: 100vw;
        height: 100vh;
        transform: scale(3.3);
    }
</style>
